import React from 'react'
import PropTypes from 'prop-types'
import { GridWrapper, ChartBubble } from './ProvidersChart.styles'
import InfoLabel from '../Labels/InfoLabel'
import { formatPercentage, minFormatter } from '../../modules/utils/formatters'
import theme from '../../config/styles/theme'

const ProvidersChart = ({ ChartData, distType, fetching }) => {
  const percentagesByTypes = {
    montoBrutoCLPAnualTP: 'percentageAmount',
    nroOCAnualTP: 'percentageOC',
    percentage: 'percentage'
  }
  const valuesByTypes = {
    montoBrutoCLPAnualTP: item => `$${minFormatter(item.totalAmount)}`,
    nroOCAnualTP: item => item.totalOC,
    percentage: item => formatPercentage(item.percentage)
  }

  return (
    <GridWrapper container justifyContent="center">
      <GridWrapper item xs={12} margin="24px 0 48px 0">
        <InfoLabel label="Micro" color={theme.palette.charts.ruby} margin="0 25px 0 0" />
        <InfoLabel label="Pequeña" color={theme.palette.charts.grape} margin="0 25px 0 0" />
        <InfoLabel label="Mediana" color={theme.palette.charts.purpleHeart} margin="0 25px 0 0" />
        <InfoLabel label="Grande" color={theme.palette.charts.dodgerBlue} margin="0 25px 0 0" />
        <InfoLabel label="Sin clasificación" color={theme.palette.charts.teal} />
      </GridWrapper>
      {ChartData.map(item => (
        <GridWrapper item key={item.ProvidersCat} xs={12} sm={6} md margin="16px 0 0" padding="0 0 16px">
          <ChartBubble
            className={fetching ? 'changed' : null}
            color={item.color}
            value={
              distType === 'percentage' ? item[percentagesByTypes[distType]] * 8 : item[percentagesByTypes[distType]]
            }
          >
            {valuesByTypes[distType](item)}
          </ChartBubble>
        </GridWrapper>
      ))}
    </GridWrapper>
  )
}

ProvidersChart.propTypes = {
  ChartData: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      percentage: PropTypes.number,
      percentageAmount: PropTypes.number,
      percentageOC: PropTypes.number,
      ProvidersCat: PropTypes.string,
      totalAmount: PropTypes.number,
      totalOC: PropTypes.number
    })
  ),
  distType: PropTypes.string,
  fetching: PropTypes.bool
}

export default ProvidersChart
